module.exports = __webpack_public_path__ + "img/teamyou.d6fa85b2.png";